var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"dashboard"}},[(_vm.loading)?_c('div',{staticClass:"admin-loading-container"},[_c('img',{attrs:{"src":require("@shared/assets/img/general/loading.svg")}})]):_c('fragment',[(_vm.currentPage !== '/reset'
        && !_vm.currentPage.includes('/lead/')
        && _vm.currentPage !== '/expired-link'
        && _vm.currentPage !== '/expired-link/reset'
        && _vm.currentPage !== '/download/pro-app'
        && _vm.currentPage !== '/virtual-visit-instructions'
      )?_c('Navbar'):_vm._e(),_c('div',{class:[!_vm.currentPage.includes('/lead/') ? 'd-container margin' : 'd-container']},[_c('router-view')],1),(!_vm.currentPage.includes('/lead/'))?_c('FooterComponent'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }